import { render, staticRenderFns } from "./DashboardStorekeeper.vue?vue&type=template&id=39e6170b&"
import script from "./DashboardStorekeeper.vue?vue&type=script&lang=js&"
export * from "./DashboardStorekeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports